<form [formGroup]="menuService?.form" (ngSubmit)="saveAndContinue()" class="px-0 px-sm-3">
    <div class="container-fluid" [ngClass]="{ 'py-5 position-relative': isDialog }">
        <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" *ngIf="isDialog"
            (click)="dialogRef.close()"></i>
        <h4 *ngIf="isDialog" class="text-bold text-center px-3">
            Zona de publicación
        </h4>
        <div class="row">
            <div class="col-md-12" *ngIf="canSeeFinancialInformationSection && !isDialog">
                <label class="text-bold">Resumen de valores</label>
                <mat-list class="col-md-12 px-0 content-financial">
                    <!-- Valor de la tarifa -->
                    <mat-list-item class="row h-auto" *ngIf="hasPermissionShowRate">
                        <div class="w-100 item-financial">
                            <div>Valor de la tarifa</div>
                            <div class="item-price">
                                {{rate | currency:'COP':'code':'0.2'}}
                            </div>
                        </div>
                    </mat-list-item>
                    <mat-list-item class="row h-auto ng-star-inserted"
                        *ngIf="menuService.isTransportService() || menuService.isEscortedService()">
                        <div class="w-100 item-financial">
                            <div>Valor total del servicio</div>
                            <div class="item-price">
                                {{totalCost | currency:'COP':'code':'0.2'}}
                            </div>
                        </div>
                    </mat-list-item>
                    <mat-list-item class="row h-auto ng-star-inserted" *ngIf="menuService.isTransportService()">
                        <div class="w-100 item-financial">
                            <div>
                                Valor de reteica ({{reteicaPercentage}}%):
                            </div>
                            <div class="item-price">
                                {{reteicaValue | currency:'COP':'code':'0.2'}}
                            </div>
                        </div>
                    </mat-list-item>
                    <mat-list-item class="row h-auto ng-star-inserted" *ngIf="menuService.isTransportService()">
                        <div class="w-100 item-financial">
                            <div>Valor de retefuente ({{reteftePercentage}}%)</div>
                            <div class="item-price">
                                {{retefteValue | currency:'COP':'code':'0.2'}}
                            </div>
                        </div>
                    </mat-list-item>
                    <mat-list-item class="row h-auto ng-star-inserted"
                        *ngIf="menuService.isTransportService() && fopatValue">
                        <div class="w-100 item-financial">
                            <div>Retención FOPAT ({{fopatPercentage}}%)</div>
                            <div class="item-price">
                                {{fopatValue | currency:'COP':'code':'0.2'}}
                            </div>
                        </div>
                    </mat-list-item>
                    <mat-list-item class="row h-auto"
                        *ngIf="menuService?.form?.get('additionalServices')?.value?.length && hasPermissionsCosts && menuService.isTransportService()">
                        <div class="w-100 item-financial">
                            <div>Valor de servicios adicionales al flete</div>
                            <div class="item-price">
                                {{additionalServicesCost | currency:'COP':'code':'0.2'}}
                            </div>
                        </div>
                    </mat-list-item>
                    <mat-list-item class="row h-auto"
                        *ngIf="menuService?.form?.get('additionalServices')?.value?.length && hasPermissionsRate && menuService.isTransportService()">
                        <div class="w-100 item-financial">
                            <div>Valor de servicios adicionales a la tarifa</div>
                            <div class="item-price">
                                {{additionalServicesRate | currency:'COP':'code':'0.2'}}
                            </div>
                        </div>
                    </mat-list-item>
                    <mat-list-item class="row h-auto" *ngIf="showAppUsageDiscount && menuService.isTransportService()">
                        <div class="w-100 item-financial">
                            <div>Servicios Tecnológicos en Nube - Plataforma Digital de Transporte / Servicios
                                adicionales
                                {{utils.isDefined(menuService?.form?.get('shippingCost.integralValue')?.value) ?
                                '(' + menuService?.form?.get('shippingCost.integralValuesPercentage')?.value + '%)' :
                                ''}}
                            </div>
                            <div class="item-price">
                                {{vehicleInsuranceDiscountCargo | currency:'COP':'code':'0.2'}}
                            </div>
                        </div>
                    </mat-list-item>
                </mat-list>
            </div>
            <div class="col-md-12 mt-4" *ngIf="canSeeVehicleAssignedInfo && !isDialog">
                <label class="text-bold">Información del vehículo asignado</label>
                <mat-list class="col-md-12 px-0 content-financial">
                    <mat-list-item class="row h-auto ng-star-inserted">
                        <div class="w-100 item-financial">
                            <div>Placa</div>
                            <div class="item-price">
                                {{menuService?.form?.get('licensePlate')?.value}}
                            </div>
                        </div>
                    </mat-list-item>
                    <mat-list-item class="row h-auto ng-star-inserted" *ngIf="menuService?.form?.get('driver')?.value">
                        <div class="w-100 item-financial">
                            <div>Conductor</div>
                            <div class="item-price">
                                {{menuService?.form?.get('driver')?.value}}
                            </div>
                        </div>
                    </mat-list-item>
                    <mat-list-item class="row h-auto ng-star-inserted" *ngIf="menuService?.form?.get('owner')?.value">
                        <div class="w-100 item-financial">
                            <div>Propietario</div>
                            <div class="item-price">
                                {{menuService?.form?.get('owner')?.value}}
                            </div>
                        </div>
                    </mat-list-item>
                    <mat-list-item class="row h-auto ng-star-inserted"
                        *ngIf="menuService?.form?.get('administrator')?.value">
                        <div class="w-100 item-financial">
                            <div>Administrador</div>
                            <div class="item-price">
                                {{menuService?.form?.get('administrator')?.value}}
                            </div>
                        </div>
                    </mat-list-item>
                    <mat-list-item class="row h-auto ng-star-inserted"
                        *ngIf="menuService?.form?.get('assignedVehicleFingerPrint')?.value?.userName">
                        <div class="w-100 item-financial">
                            <div>Asignado por</div>
                            <div class="item-price">
                                {{menuService?.form?.get('assignedVehicleFingerPrint')?.value?.userName}}
                            </div>
                        </div>
                    </mat-list-item>
                </mat-list>
            </div>
            <ng-container *ngIf="canSeeAndEditPublicationZone">
                <p class="col-12 mt-4 text-bold">Publicación</p>
                <div class="col-md-12">
                    <mat-radio-group [formControl]="publicationZone" class="flex-column">
                        <mat-radio-button *ngFor="let zone of publicationZones" [value]="zone.value">
                            <p class="zone-radio-button mb-0">
                                <b>{{zone.name}}:</b> {{zone.description}}
                            </p>
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </ng-container>
        </div>
        <div *ngIf="!canSeeFinancialInformationSection && !canSeeAndEditPublicationZone"
            class="no-permission-container">
            <i class="fas fa-exclamation-circle fa-lg m-2"></i>
            <h4 class="text-bold">No tienes permiso para acceder a esta información. Contacta a tu administrador para
                solicitar acceso.</h4>
        </div>
        <!-- Action Buttons Section -->
        <div class="button-container mt-4" *ngIf="!isDialog; else dialogButtons">
            <button mat-raised-button color="primary" class="button-width-auto primary-secondary button-small"
                [ngClass]="{'warn': true}" type="button" (click)="backToPreviousStep()">
                <span class="mat-button-wrapper">Atras</span>
            </button>
            <button class="mx-2" type="submit" mat-raised-button color="accent" *ngIf="canSeeAndEditPublicationZone">
                Guardar
            </button>
            <button mat-raised-button color="accent" type="button" (click)="createCargo()"
                *ngIf="canCreateCargoFromRequest"
                [ngClass]="{'disabled-btn': !menuService?.isValidEntireCargo().isValid}"
                [matTooltip]="menuService?.isValidEntireCargo().error" matTooltipClass="tooltip__error">
                {{menuService?.cargo?.ministry? 'Crear remesas' : 'Finalizar solicitud'}}
            </button>
        </div>
        <ng-template #dialogButtons>
            <div class="button-container mt-4">
                <button class="mx-2" type="submit" mat-raised-button color="accent">
                    Guardar
                </button>
            </div>
        </ng-template>
    </div>
</form>